import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import UserViewContainer from '@src/components/user/view/UserViewContainer';

const UserPage = (props: WithRouterProps) => <UserViewContainer userId={props.params.userId} openedTab={props.params.openedTab} />;

export default withRouter(UserPage);
